// Utils
import { propIn } from '../../../common/utils/immutableHelper';

// Constants
import {
    DELETE_TASKS_SUGGESTION_DISMISSED_PROPERTY,
    SHOW_TITLE_PROPERTY,
    TITLE_SUGGESTION_ACK_PROPERTY,
} from '../../../common/taskLists/taskListConstants';

// Property Accessors
export const getShowTitle = propIn(['content', SHOW_TITLE_PROPERTY]);
export const getTitleSuggestionAck = propIn(['content', TITLE_SUGGESTION_ACK_PROPERTY]);
export const getDeleteTasksSuggestionDismissed = propIn(['content', DELETE_TASKS_SUGGESTION_DISMISSED_PROPERTY]);
